import requestConfig from 'config/requestExodus';
import { API_EXODUS_URL } from 'constants/api';
import { APIResponse } from '../../../@types/api-response';

const NOTES_URL = `${API_EXODUS_URL}/notes`;

const request = requestConfig();

export const postNotes = (payload: PostNotesPayload) =>
  request.post(NOTES_URL, payload);

export const getNotes = (params?: GetNotesParams): Promise<APIResponse<GetNotesResponse>> =>
  request.get(NOTES_URL, { params });

export const putNotes = (payload: PutNotesPayload, id: number) =>
  request.put(`${NOTES_URL}/${id}`, payload);

export const deleteNotes = (id: number) =>
  request.delete(`${NOTES_URL}/${id}`);
